<section class="rs-content-wrapper rs-header-has-level2">
  <main id="maincontent" role="main">
    <section class="rs-es-first-section">
      <div class="row">
        <div class="columns small-12">
          <div class="small-only-text-center">
            <div
              class="panel rs-inline-block rs-wd-s30 rs-wd-m31 rs-h-s4 rs-h-m5 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
            ></div>
          </div>

          <div
            class="panel rs-wd-s14 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
          ></div>

          <div class="rs-panel-big rs-bg-c2 clearfix">
            <div class="small-only-text-center">
              <div
                class="panel rs-inline-block rs-wd-s6 rs-wd-m10 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
              ></div>
            </div>

            <div class="row">
              <div class="columns small-12 medium-6">
                <div class="panel rs-bg-grey1">
                  <div class="text-center">
                    <div
                      class="panel rs-inline-block rs-wd-s23 rs-wd-m37 rs-h-s23 rs-h-m37 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                    ></div>
                  </div>
                </div>
              </div>
              <div class="columns small-12 medium-6">
                <div class="panel rs-bg-grey1 rs-no-margin rs-no-radius-bottom clearfix">
                  <div
                    class="panel rs-wd-s15 rs-wd-m23 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                  ></div>
                  <div
                    class="panel rs-wd-s13 rs-wd-m19 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                  ></div>
                  <div
                    class="panel rs-wd-s14 rs-wd-m20 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                  ></div>
                </div>
                <div class="panel rs-bg-grey2 rs-no-radius-top clearfix">
                  <div
                    class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                  ></div>
                  <div
                    class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading hide-for-medium-up"
                  ></div>
                  <div
                    class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div class="rs-le2"></div>
        </div>
      </div>
    </section>
  </main>
</section>
